export enum tenantConstants {
  getTenantListRequest = "GET_TENANT_LIST_REQUEST",
  getTenantListSuccess = "GET_TENANT_LIST_SUCCESS",
  getTenantListFailure = "GET_TENANT_LIST_FAILURE",

  getHeaderTenantListRequest = "GET_HEADER_TENANT_LIST_REQUEST",
  getHeaderTenantListSuccess = "GET_HEADER_TENANT_LIST_SUCCESS",
  getHeaderTenantListFailure = "GET_HEADER_TENANT_LIST_FAILURE",

  tenantSaveRequest = "TENANT_SAVE_REQUEST",
  tenantSaveSuccess = "TENANT_SAVE_SUCCESS",
  tenantSaveFailure = "TENANT_SAVE_FAILURE",

  tenantViewRequest = "TENANT_VIEW_REQUEST",
  tenantViewSuccess = "TENANT_VIEW_SUCCESS",
  tenantViewFailure = "TENANT_VIEW_FAILURE",

  getAccessControlRequest = "GET_ACCESS_CONTROL_REQUEST",
  getAccessControlSuccess = "GET_ACCESS_CONTROL_SUCCESS",
  getAccessControlFailure = "GET_ACCESS_CONTROL_FAILURE",

  saveAccessControlRequest = "SAVE_ACCESS_CONTROL_REQUEST",
  saveAccessControlSuccess = "SAVE_ACCESS_CONTROL_SUCCESS",
  saveAccessControlFailure = "SAVE_ACCESS_CONTROL_FAILURE",
}
